import React from 'react';
import { Outlet, type RouteProps } from 'react-router-dom';

import Layout from '../layout';
import { useTranslation } from 'react-i18next';

const PublicRoute: React.FC<
  RouteProps & {
    page?: string;
    title: string;
  }
> = ({ children, page, title }) => {
  const { t } = useTranslation();
  return (
    <Layout page={page} title={t(title)}>
      {children ? children : <Outlet />}
    </Layout>
  );
};

export default PublicRoute;
